module.exports = __webpack_public_path__ + "as.no1.12ae5bf4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/as.no1.jpg
// module id = yeoZ
// module chunks = 0